// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7EyAP","userImg":"styles_userImg__IPMgM","icon":"styles_icon__aheVx"};